import { useEffect, useRef } from "react";
import { useLoaderData, useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch } from "../redux/hooks";
import { updateSessionId, updateTableNumber, getCreateResult } from "../redux/slices";
//import { Loading } from './Loading';
import { SessionCheckResponse } from "../types/player";
import ReactGA from "react-ga4";
import { useSelector } from "react-redux";

export const ValidateLink: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionStatus = useLoaderData() as SessionCheckResponse;
  let sessionId = searchParams.get("s");
  let tableNumber = searchParams.get("t");
  const dispatch = useAppDispatch();
  const gaFired = useRef<boolean>(false);

  const createResult = useSelector(getCreateResult);

  const playerUid = createResult.playerUid;

  useEffect(() => {
    ReactGA.initialize("G-7V3X25H5M2");
    ReactGA.set({ venue_code: sessionStatus?.venueCode });

    if (sessionId === null) {
      navigate(`/invalidlink?session`);
      return;
    }

    switch (sessionStatus?.status) {
      case "Started":
        if (!gaFired.current) {
          gaFired.current = true;
          ReactGA.event("RapidEntryStarted", {
            venue_code: sessionStatus?.venueCode,
          });
        }
        dispatch(updateSessionId(sessionId));
        dispatch(updateTableNumber(tableNumber));
        navigate(`/nickname?s=${sessionId}&t=${tableNumber}&v=${sessionStatus?.venueCode}`);
        break;
      case "Finished":
        const lastUpdated = sessionStatus?.last_updated
          ? new Date(sessionStatus.last_updated).toISOString().slice(0, 19)
          : "";
        navigate(`/sessioncompleted?s=${sessionId}&d=${lastUpdated}&p=${playerUid}`);
        break;
      case "Pending":
        navigate(`/invalidlink?pending`);
        break;
      case "Not Found":
      case null:
      case undefined:
        navigate(`/invalidlink?undefined`);
        break;
    }
  }, [sessionStatus, navigate, sessionId, tableNumber, dispatch, playerUid]);

  // switch (sessionStatus) {
  //     case "Wait":
  //         return (<Wait />);
  // }
  return <></>;
};
